import "./style/index.css?global";
import { Radio } from "antd";

// @ts-ignore
Radio.Group.name = "RadioGroup";
export default Radio;